import { Component, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { Pagination } from 'swiper';

SwiperCore.use([Pagination]);

@Component({
  selector: 'app-fullscreen-gallery',
  templateUrl: './fullscreen-gallery.component.html',
  styleUrls: ['./fullscreen-gallery.component.scss'],
})
export class FullscreenGalleryComponent {

  @Input() public images = [];
  @Input() activeIndex : number;
  @ViewChild('gallerySlides',{static: false}) slidesRefs: SwiperComponent;

  public sliderOptions: SwiperOptions = {};

  constructor(private modalController: ModalController) {
  }

  dismiss() {
    this.modalController.dismiss();
  }

  isZooming(zoomLevel) {
    if (zoomLevel !== 1) {
      this.slidesRefs.swiperRef.disable();
    } else {
      this.slidesRefs.swiperRef.enable();
    }
  }
}
